import mergeWith from "lodash/mergeWith"
import produce from "immer"
import settings from "./conf"
import { isMobileViewport, getViewportType } from "./slices/ui"

const mergeState = (objValue, srcValue, key, object, source, stack) => {
    if (key == 'pagination' || key== 'infoPanel'){
        return srcValue
    }
}

export const mapLocationToState = (state, location) => {
  switch(location.pathname) {
    default:
      const stateFromLocation = location.query
      return produce(state, (draft) => mergeWith(draft, stateFromLocation, mergeState))
  }
}

const serializeInfoPanel = (value) => {
    switch (value && value.type){
      case 'waypoint':
        return 'w-' + value.quadhash
      case 'poi':
        return 'p-' + value.id
      case 'accommodation':
        return 'a-' + value.id
      case 'step':
        return 's-' + value.step_trail_id + '-' + value.step_id
      default:
        return null
    }
}

const parseInfoPanel = (value) => {
    switch (value[0]){
      case 'w':
        return {
          type: 'waypoint',
          quadhash: value.split('-')[1]
        }
      case 'p':
        return {
          type: 'poi',
          id: value.split('-')[1]
        }
      case 'a':
        return {
          type: 'accommodation',
          id: value.split('-')[1]
        }
      case 's':
        const [prefix, trail_id, step_id] = value.split('-')
        return {
          type: 'step',
          step_trail_id: parseInt(trail_id),
          step_id: parseInt(step_id)
        }
      default:
        return null
    }
}

const serializeMapPanel = (mapPanel) => {
  return (mapPanel && isMobileViewport(getViewportType())) ? true : null
}

const parseMapPanel = (value) => {
  return value || false
}


export const serializeAvailability = (availability) => {
  if (!availability || !availability.date) {
    return
  }
  return  `${availability.date.getFullYear()}-${availability.date.getMonth() + 1}-${availability.date.getDate()}-${availability.guest}-${availability.nigth}`
}

export const parseAvailability = (value) => {
  const availability = value.split('-')
  return {
    date: new Date(availability.slice(0,3).join('-')),
    guest: parseInt(availability[3]),
    nigth: parseInt(availability[4])
  }
}


export const location = {
  global: {
    s: {stateKey: 'ui.sidebar', options: {shouldPush: true}, initialState: null},
    m: {stateKey: 'ui.mapPanel', type:'bool' ,options: {shouldPush: true, serialize: serializeMapPanel, parse: parseMapPanel}, initialState: null},
    i: {stateKey: 'ui.infoPanel', options: {shouldPush: true, serialize: serializeInfoPanel, parse: parseInfoPanel }, initialState:{}, type:'object'},
    p: {stateKey: 'ui.pagination', options: {shouldPush: false}, initialState: {}, type:'object'},
    u: {stateKey: 'settings.unit', options: {shouldPush: false}},
    h: {stateKey: 'settings.speed', options: {shouldPush: false}, type:'number'},
    a: {stateKey: 'accommodation.order', options: {shouldPush: false}, initialState: settings.USER_SETTINGS.accommodationOrder},
    r: {stateKey: 'accommodation.availability', options: {shouldPush: false, serialize: serializeAvailability, parse: parseAvailability}, initialState: null},
  }
}

export default location
